import { useQuery } from '@tanstack/react-query'
import { CheckSquare, Clock, CheckCircle2, XCircle } from 'lucide-react'
import { supabase } from '@/lib/supabase'
import ValidationQueue from '@/components/activities/ValidationQueue'

// =============================================================================
// ValidationPage — Supervisor-only validation management
// =============================================================================

export default function ValidationPage() {
  // Stats for header
  const { data: stats } = useQuery({
    queryKey: ['validation-stats'],
    queryFn: async () => {
      const { data } = await supabase
        .from('validations')
        .select('status')

      const all = data ?? []
      return {
        pendiente:   all.filter((v) => v.status === 'PENDIENTE').length,
        aprobado:    all.filter((v) => v.status === 'APROBADO').length,
        rechazado:   all.filter((v) => v.status === 'RECHAZADO').length,
        en_revision: all.filter((v) => v.status === 'EN_REVISION').length,
      }
    },
    staleTime: 30_000,
  })

  const statCards = [
    {
      label: 'Pendientes',
      value: stats?.pendiente   ?? 0,
      icon:  Clock,
      color: 'text-yellow-600',
      bg:    'bg-yellow-50',
    },
    {
      label: 'Aprobadas',
      value: stats?.aprobado    ?? 0,
      icon:  CheckCircle2,
      color: 'text-green-600',
      bg:    'bg-green-50',
    },
    {
      label: 'Rechazadas',
      value: stats?.rechazado   ?? 0,
      icon:  XCircle,
      color: 'text-red-600',
      bg:    'bg-red-50',
    },
    {
      label: 'En revisión',
      value: stats?.en_revision ?? 0,
      icon:  CheckSquare,
      color: 'text-orange-600',
      bg:    'bg-orange-50',
    },
  ]

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-xl font-bold text-gray-900">Cola de Validaciones</h2>
        <p className="text-sm text-gray-500 mt-0.5">
          Revisar y aprobar los avances propuestos por subcontratistas
        </p>
      </div>

      {/* Stat mini-cards */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {statCards.map((c) => {
          const Icon = c.icon
          return (
            <div key={c.label} className="card p-4 flex items-center gap-3">
              <div className={`p-2.5 rounded-xl ${c.bg}`}>
                <Icon className={`w-5 h-5 ${c.color}`} />
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">{c.value}</p>
                <p className="text-xs text-gray-500">{c.label}</p>
              </div>
            </div>
          )
        })}
      </div>

      {/* Validation queue */}
      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-3">
          Validaciones pendientes de revisión
        </h3>
        <ValidationQueue />
      </div>
    </div>
  )
}
